//cacheLife em segundos
//cacheAutoCheck serve para antes da operação no banco local, fazer as verificações de integridade
export const DataBaseEnum = Object.freeze({
    PRICE_RADAR_CACHE: { name: "PRICE_RADAR_CACHE", cacheLife: 60 * 60, cacheAutoCheck: true },
    HELPER_POP_UP: { name: "HELPER_POP_UP", cacheLife: 0, cacheAutoCheck: false },
    USER: { name: "USER", cacheLife: 60 * 60, cacheAutoCheck: true },
    USER_UNAUTHORIZED: { name: "USER_UNAUTHORIZED", cacheLife: 0, cacheAutoCheck: false },
    PROMO_HUB_MURAL_POST: { name: "PROMO_HUB_MURAL_POST", cacheLife: 60 * 5, cacheAutoCheck: false },
    HOME_BANNER_LIST: { name: "HOME_BANNER_LIST", cacheLife: 60 * 30 /** 30 minutos cache */, cacheAutoCheck: true },
    USER_AUTHENTICATED: { name: "USER_AUTHENTICATED", cacheLife: 0, cacheAutoCheck: false },
    MAINTENANCE_CHECK: { name: "MAINTENANCE_CHECK", cacheLife: 30, cacheAutoCheck: true },
    APP_VERSION: { name: "APP_VERSION", cacheLife: 0, cacheAutoCheck: false },
});